//#region Components
import DialogAlert from "components/DialogAlert/DialogAlert";
import CloseButton from "components/CloseButton/CloseButton";
//#endregion
//#region Styles
import {
    Container,
    Content, Footer } from "./styles";
//#endregion
//#region Images
import actionImage from "img/action_image.svg";
//#endregion

const DialogAlertAction = ({
    show, toggleShow, 
    title, content, contentComponent, 
    noImage = false, 
    variant, children, close, 
    minWidth, width,
    widthContent,
    spacingContainer
}) => {
    return (
        <DialogAlert
            show={show}
            toggleShow={toggleShow}
            close={close}
            width={width}>
            <CloseButton 
                color="var(--light-blue-4)" 
                onClick={close ?? (() => toggleShow(false))}/>
            <Container minWidth={minWidth} gap={spacingContainer}>
                <Content 
                    className={contentComponent ? "content-component" : ""}
                    width={widthContent}>
                    {!noImage && <img src={actionImage} alt="Imagen de una acción UTP"/>}
                    {title && <h3 className={variant}>{title}</h3>}
                    {contentComponent 
                        ? contentComponent 
                        : <p className="paragraph center">{content}</p>}
                </Content>
                {children
                    ? <Footer>
                        {children}
                    </Footer>
                    : null}
            </Container>
        </DialogAlert>
    );
}

export default DialogAlertAction;
